import { Alert, Box, Button, Typography } from "@mui/material";
import { FC } from "react";
import { Dialog } from "~/components/dialog";
import { $dayjs, DATEYEARMONTH_FORMAT } from "~/libs/dayjs";
import { useGetCurrentFile } from "~/queries/useGetFileById";
export const DeleteFileDialog: FC<{
  handleConfirm: (fildId: string) => Promise<void>;
  onClose: () => void;
}> = ({
  handleConfirm,
  onClose
}) => {
  const {
    data: file
  } = useGetCurrentFile();
  if (!file) return;
  return <Dialog dialogProps={{
    maxWidth: "sm"
  }} title={`Delete Order`} content={<>
					<Box sx={{
      display: "flex",
      mb: 2
    }}>
						<Alert severity="error" sx={{
        width: "100%"
      }}>
							Delete Order? This action cannot be undone.
						</Alert>
					</Box>
					<Box sx={{
      display: "flex",
      flexDirection: "column",
      mb: 2
    }}>
						<Typography>
							<strong>Order #: </strong>
							{`${file.counterConfigs?.file?._counter.isPredefinedFormat ? `${$dayjs(file.createdAt).format(DATEYEARMONTH_FORMAT)}` : file.counterConfigs?.file?._counter.prefix}-${file.counterConfigs?.file?.index ? String(file.counterConfigs.file?.index || 0).padStart(file.counterConfigs.file?._counter?.suffix_digit || 0, "0") : ""}${file.fileSuffixComment ? `-${file.fileSuffixComment}` : ""}`}
						</Typography>
						<Typography>
							<strong>
								{file._receipt ? file._receipt.isFullyPaid ? "Receipt " : "Invoice " : "Invoice "}
								#:{" "}
							</strong>
							{`${file.counterConfigs?.invoice?._counter.isPredefinedFormat ? `${$dayjs(file.createdAt).format(DATEYEARMONTH_FORMAT)}` : file.counterConfigs?.invoice?._counter.prefix}-${file.counterConfigs?.invoice?.index ? String(file.counterConfigs.invoice?.index || 0).padStart(file.counterConfigs.invoice?._counter?.suffix_digit || 0, "0") : ""}${file.receiptSuffixComment ? `-${file.receiptSuffixComment}` : ""}`}
						</Typography>
					</Box>
					<Box sx={{
      display: "flex",
      my: 2
    }}>
						<Button variant="contained" fullWidth onClick={() => {
        void handleConfirm(file._id);
      }}>
							Delete
						</Button>
					</Box>
					<Box sx={{
      display: "flex",
      mb: 2
    }}>
						<Button variant="outlined" fullWidth onClick={onClose}>
							Cancel
						</Button>
					</Box>
				</>} data-sentry-element="Dialog" data-sentry-component="DeleteFileDialog" data-sentry-source-file="delete-file-dialog.tsx" />;
};